export default class NumberButton extends HTMLElement {
  constructor() {
    super();
    this.abortController;
    this.input = this.querySelector('input[type=number]');
    this.btns = this.querySelectorAll('button[data-icon]');
  }

  connectedCallback() {
    /* console.log(`NumberButton > connectedCallback`); */
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.btns.forEach(btn => {
      btn.addEventListener('click', (e) => this.onBtnClick(e.target.dataset.icon), { signal });
    });
  }

  disconnectedCallback() {
    /* console.log(`NumberButton > disconnectedCallback`); */
    this.abortController.abort();
    this.abortController = null;
  }

  static get observedAttributes() {
    return ['data-value'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-value') {
      this.input.value = newValue;
    }
  }

  onBtnClick(icon) {
    if (icon === 'minus') {
      this.input.stepDown();
      this.input.dispatchEvent(new Event('input'));
    }

    if (icon === 'plus') {
      this.input.stepUp();
      this.input.dispatchEvent(new Event('input'));
    }
  }
}

customElements.define('number-button', NumberButton);